export default {
  siteName: ''
}
